
import Ghost from "../../../assets/outline/Ghost.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GhostIcon({ className, dataTestid = "GhostIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ghost data-testid={dataTestid} className={classes} {...rest} />
  );
}
